import React from "react";
import Layout from "../common/Layout";
import Intro from "../components/about/Intro";
import TimelineSection from "../components/about/TimelineSection";
import OurValuesSection from "../components/about/OurValuesSection";
import OurClientsSection from "../components/about/OurClientsSection";
import PageHeaderWithLoader from "../common/PageHeaderWithLoader";
// import aboutUsBackground from "../assets/aboutUs.png"; // Ensure this path is correct

const AboutUs = () => {
  return (
    <Layout>
      <PageHeaderWithLoader title="About Us" media={{ type: "image", src: process.env.PUBLIC_URL + "/assets/aboutUs.webp" }} />
      <Intro />
      <TimelineSection />
      <OurValuesSection  />
      <OurClientsSection />
    </Layout>
  );
};

export default AboutUs; 
